const options = {
  5: "bg-yellow-200/5",
  10: "bg-yellow-200/10",
  25: "bg-yellow-200/25",
  50: "bg-yellow-200/50",
  75: "bg-yellow-200/75",
  90: "bg-yellow-200/90",
  100: "bg-yellow-200",
};

const from = {
  5: "from-yellow-200/5",
  10: "from-yellow-200/10",
  25: "from-yellow-200/25",
  50: "from-yellow-200/50",
  75: "from-yellow-200/75",
  90: "from-yellow-200/90",
  100: "from-yellow-200",
};

export default function getBackgroundYellow200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
